module.exports = __webpack_public_path__ + "img/digital-film-download-colour.b3ddefff.jpg";